"use strict";
/*
  based on: https://github.com/rzeigler/waveguide/blob/master/src/deferred.ts
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var completable_1 = require("./original/support/completable");
var T = __importStar(require("./effect"));
var effect_1 = require("./effect");
var DeferredImpl = /** @class */ (function () {
    function DeferredImpl(r) {
        var _this = this;
        this.r = r;
        this.c = new completable_1.CompletableImpl();
        this.wait = T.flatten(T.asyncTotal(function (callback) { return _this.c.listen(callback); }));
        this.interrupt = T.sync(function () {
            _this.c.complete(T.raiseInterrupt);
        });
    }
    DeferredImpl.prototype.done = function (a) {
        var _this = this;
        return T.sync(function () {
            _this.c.complete(T.pure(a));
        });
    };
    DeferredImpl.prototype.error = function (e) {
        var _this = this;
        return T.sync(function () {
            _this.c.complete(T.raiseError(e));
        });
    };
    DeferredImpl.prototype.abort = function (e) {
        var _this = this;
        return T.sync(function () {
            _this.c.complete(T.raiseAbort(e));
        });
    };
    DeferredImpl.prototype.cause = function (e) {
        var _this = this;
        return T.sync(function () {
            _this.c.complete(T.raised(e));
        });
    };
    DeferredImpl.prototype.complete = function (exit) {
        var _this = this;
        return T.sync(function () {
            _this.c.complete(T.completed(exit));
        });
    };
    DeferredImpl.prototype.from = function (source) {
        var _this = this;
        var completed = effect_1.effect.chain(T.result(T.provide(this.r)(source)), function (e) {
            return _this.complete(e);
        });
        return T.effect.onInterrupted(completed, this.interrupt);
    };
    return DeferredImpl;
}());
exports.DeferredImpl = DeferredImpl;
function makeDeferred() {
    return T.access(function (r) { return new DeferredImpl(r); });
}
exports.makeDeferred = makeDeferred;
